/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface BillingContactUpdateRequest
 */
export interface BillingContactUpdateRequest {
    /**
     * 
     * @type {string}
     * @memberof BillingContactUpdateRequest
     */
    firstName?: string;
    /**
     * 
     * @type {string}
     * @memberof BillingContactUpdateRequest
     */
    lastName?: string;
    /**
     * 
     * @type {string}
     * @memberof BillingContactUpdateRequest
     */
    email: string;
    /**
     * 
     * @type {Set<string>}
     * @memberof BillingContactUpdateRequest
     */
    extraEmails: Set<string>;
    /**
     * 
     * @type {string}
     * @memberof BillingContactUpdateRequest
     */
    phoneNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof BillingContactUpdateRequest
     */
    paymentReminderContact?: string;
    /**
     * 
     * @type {boolean}
     * @memberof BillingContactUpdateRequest
     */
    isSeparateEmailsForInvoices: boolean;
}

/**
 * Check if a given object implements the BillingContactUpdateRequest interface.
 */
export function instanceOfBillingContactUpdateRequest(value: object): value is BillingContactUpdateRequest {
    if (!('email' in value) || value['email'] === undefined) return false;
    if (!('extraEmails' in value) || value['extraEmails'] === undefined) return false;
    if (!('isSeparateEmailsForInvoices' in value) || value['isSeparateEmailsForInvoices'] === undefined) return false;
    return true;
}

export function BillingContactUpdateRequestFromJSON(json: any): BillingContactUpdateRequest {
    return BillingContactUpdateRequestFromJSONTyped(json, false);
}

export function BillingContactUpdateRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): BillingContactUpdateRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'firstName': json['firstName'] == null ? undefined : json['firstName'],
        'lastName': json['lastName'] == null ? undefined : json['lastName'],
        'email': json['email'],
        'extraEmails': json['extraEmails'],
        'phoneNumber': json['phoneNumber'] == null ? undefined : json['phoneNumber'],
        'paymentReminderContact': json['paymentReminderContact'] == null ? undefined : json['paymentReminderContact'],
        'isSeparateEmailsForInvoices': json['isSeparateEmailsForInvoices'],
    };
}

export function BillingContactUpdateRequestToJSON(value?: BillingContactUpdateRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'firstName': value['firstName'],
        'lastName': value['lastName'],
        'email': value['email'],
        'extraEmails': Array.from(value['extraEmails'] as Set<any>),
        'phoneNumber': value['phoneNumber'],
        'paymentReminderContact': value['paymentReminderContact'],
        'isSeparateEmailsForInvoices': value['isSeparateEmailsForInvoices'],
    };
}

